import { Observable, map } from 'rxjs';

import { ApiWishlist } from '../../domain/models/wishlist.models';
import { WishlistApiRepository } from '../../infrastructure/api/wishlist.api.repository';
import { WishlistModelsTransformer } from '../transformers/wishlist.transformer';

import { StoreAndLanguage } from '@core/domain/state/core.state';

export function GetWishlistUseCase$(
    wishlistApiRepository: WishlistApiRepository,
    name: string,
    storeAndLanguage: StoreAndLanguage,
    catalogId: string,
    whislistUrl?: string,
): Observable<ApiWishlist> {
    return wishlistApiRepository.getWishlist(
        storeAndLanguage.storeId,
        storeAndLanguage.languageId,
        catalogId,
        null,
        whislistUrl,
    ).pipe(
        map((apiWhislist) => {
            let whislistIndex: number;
            if (apiWhislist?.wlArray && apiWhislist.wlArray.length > 0) {
                whislistIndex = apiWhislist.wlArray.findIndex((e) => e.name === name);
            }
            return whislistIndex !== undefined
                ? WishlistModelsTransformer.WishlistFromApi(apiWhislist, name)
                : { name, items: [] };
        }),
    );
}
